import script from "./CertificationToDoStart.vue?vue&type=script&setup=true&lang=ts"
export * from "./CertificationToDoStart.vue?vue&type=script&setup=true&lang=ts"

import "./CertificationToDoStart.vue?vue&type=style&index=0&id=0feb063b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0feb063b"]])

export default __exports__